import { render, staticRenderFns } from "./AssetsController.vue?vue&type=template&id=91c91fe2&scoped=true&"
import script from "./AssetsController.vue?vue&type=script&lang=js&"
export * from "./AssetsController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c91fe2",
  null
  
)

export default component.exports